import { Box } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Carousel } from "react-responsive-carousel";
import { colors } from "../../../constants/colors";
import { CarouselArrow, CarouselDot } from "./announceView.style";
import { fileUrl } from "./announceView.utils";

type Props = {
  images: any[];
  height?: number;
};

/** สไลด์รูปภาพแนบของประกาศ (คอลัมน์ขวาในหน้ารายละเอียด) */
export default function AnnounceImageSlider({ images, height = 460 }: Props) {
  const list = (images || []).filter((e: any) => e?.fileName);
  if (!list.length) return null;

  const single = list.length === 1;

  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: "12px",
        overflow: "hidden",
        border: `1px solid ${colors.black_08}`,
        ".carousel .slider-wrapper, .carousel .slide": {
          backgroundColor: colors.extraLightGray,
        },
        ".carousel .control-dots": {
          margin: 0,
          bottom: "12px",
          padding: 0,
        },
      }}
    >
      <Carousel
        showStatus={false}
        showThumbs={false}
        showArrows={!single}
        showIndicators={!single}
        autoPlay={!single}
        infiniteLoop={!single}
        interval={8000}
        transitionTime={600}
        renderArrowPrev={(onClickHandler, hasPrev) =>
          hasPrev ? (
            <CarouselArrow onClick={onClickHandler} sx={{ left: "12px" }}>
              <ChevronLeftIcon />
            </CarouselArrow>
          ) : null
        }
        renderArrowNext={(onClickHandler, hasNext) =>
          hasNext ? (
            <CarouselArrow onClick={onClickHandler} sx={{ right: "12px" }}>
              <ChevronRightIcon />
            </CarouselArrow>
          ) : null
        }
        renderIndicator={(onClickHandler, isSelected, index, label) => (
          <CarouselDot
            component="span"
            selected={isSelected}
            onClick={onClickHandler}
            onKeyDown={onClickHandler}
            key={index}
            role="button"
            tabIndex={0}
            aria-label={`${label} ${index + 1}`}
          />
        )}
      >
        {list.map((file: any, index: number) => (
          <Box
            key={file?.fileId || `img-${index}`}
            sx={{ height: { xs: "260px", sm: "360px", md: `${height}px` } }}
          >
            {/* contain ไม่ครอปรูป — อินโฟกราฟิกอ่านได้ครบทั้งภาพ */}
            <img
              src={fileUrl(file)}
              alt={file?.fileName || `announce-${index}`}
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
          </Box>
        ))}
      </Carousel>
    </Box>
  );
}
